import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BsArrowRightSquareFill } from "react-icons/bs";
import { hauptInfo } from "../helper/data";
import { Link } from "react-router-dom";

const Aktuell = () => {
  const [aktuelInfo, setAktuelInfo] = useState([]);

  useEffect(() => {
    const filteredInfo = hauptInfo.filter((info) => info.situation === "new");
    setAktuelInfo(filteredInfo);
  }, []);

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, type: "spring" },
    },
  };

  function truncateText(text, limit) {
    const words = text.split(" ");
    return words.length > limit
      ? words.slice(0, limit).join(" ") + "..."
      : text;
  }

  return (
    <div className="container-fluid bg-body-tertiary py-5 border-bottom border-3 border-top border-success">
      <h1 className="text-center text-dark mb-5 shadow-text">Aktuelles</h1>

      <div className="container">
        <div className="row g-4 justify-content-center">
          {aktuelInfo.map((info, index) => (
            <motion.div
              key={index}
              className="col-12 col-lg-6 d-flex"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              transition={{ delay: index * 0.15 }}
            >
              <motion.div
                className="card flex-lg-row w-100 h-100 shadow-lg border-0 rounded-4 overflow-hidden elegant-card"
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0 10px 40px rgba(0,0,0,.35)",
                  transition: { duration: 0.35, type: "spring" },
                }}
              >
                {/* IMAGE — hover’da zoom-in */}
                <motion.div className="col-lg-5 overflow-hidden">
                  <motion.img
                    src={info.image}
                    className="img-fluid w-100 h-100 object-fit-cover"
                    alt={info.titel}
                    style={{ aspectRatio: "4/2" }}
                    whileHover={{ scale: 1.12 }}
                    transition={{ duration: 0.5 }}
                  />
                </motion.div>

                {/* TEXT */}
                <div className="col-lg-7 p-3 p-md-4 d-flex flex-column">
                  <h5 className="text-success text-center fw-bold">
                    {info.titel}
                  </h5>
                  <p
                    className="text-secondary mt-2"
                    style={{ textAlign: "justify" }}
                  >
                    {truncateText(info.desc2, 40)}
                  </p>

                  {/* Mehr Link animasyonlu */}
                  <div className="mt-auto d-flex justify-content-between align-items-center">
                    <motion.div whileHover={{ x: 4 }}>
                      <Link
                        to={`/aktuell/${info.id}`}
                        className="fw-bold text-success fs-5 text-decoration-none"
                      >
                        Mehr <BsArrowRightSquareFill className="ms-1 fs-4" />
                      </Link>
                    </motion.div>

                    <small className="text-secondary">
                      Am{" "}
                      <span className="fw-bold text-dark">
                        {info.date || "..."}
                      </span>
                    </small>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Aktuell;
